import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OperadorasSelectors, UserProfileSelectors } from '@gestor-web/@core/store/selectors';
import { Store } from '@ngrx/store';
import { combineLatest, Subject } from 'rxjs';
import { skipWhile, switchMap, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-home-resolver',
    template: `Carregando...`,
    standalone: false
})
export class HomeResolverComponent implements OnInit, OnDestroy {
  constructor(
    private store: Store,
    private router: Router,
  ) {}

  ngOnInit() {
    this.store
      .select(OperadorasSelectors.selectOperadorasLoaded)
      .pipe(
        skipWhile(loaded => !loaded),
        switchMap(() =>
          combineLatest([
            this.store.select(OperadorasSelectors.selectWorkspaceOperadora),
            this.store.select(UserProfileSelectors.selectAbrangenciaOperadoras),
            this.store.select(UserProfileSelectors.selectUserIdssProfile),
            this.store.select(UserProfileSelectors.selectOperadorasVinculadas),
            this.store.select(OperadorasSelectors.selectOperadorasWorkspace),
          ]),
        ),
        takeUntil(this.ngDestroyed$),
      )
      .subscribe(([workspace, abrangencia, perfil, operadorasVinculadas, operadorasWorkspace]) => {
        let operadora = null;

        switch (abrangencia) {
          case 'CLIENTES':
            operadora =
              workspace?.cd_registro_ans ??
              perfil?.cd_registro_ans_preferencial ??
              operadorasWorkspace[0]?.cd_registro_ans;
            break;

          case 'VINCULO':
            operadora = this.resolveOperadoraAcessivel(
              [workspace?.cd_registro_ans, perfil?.cd_registro_ans_preferencial, operadorasVinculadas[0]?.cd_registro_ans],
              operadorasVinculadas,
            );
            break;
        }

        if (operadora) {
          return this.router.navigate(['/operadora', operadora]);
        }

        return this.router.navigate(['/dados-setor/idss/resultados-por-operadora']);
      });
  }

  /**
   * Retorna o primeiro candidato de operadora ao qual o usuário ainda tem acesso — isto é, que
   * continua presente na lista de operadoras acessíveis. Evita navegar para uma operadora
   * preferencial obsoleta (ex.: removida dos vínculos), o que levaria à tela de acesso negado.
   */
  private resolveOperadoraAcessivel(
    candidatos: Array<string | null | undefined>,
    operadorasAcessiveis: Array<{ cd_registro_ans?: string }>,
  ): string | null {
    const acessiveis = new Set((operadorasAcessiveis ?? []).map(op => String(op?.cd_registro_ans)));

    for (const candidato of candidatos) {
      if (candidato != null && acessiveis.has(String(candidato))) {
        return String(candidato);
      }
    }

    return null;
  }

  private ngDestroyed$ = new Subject<void>();
  ngOnDestroy() {
    this.ngDestroyed$.next();
    this.ngDestroyed$.complete();
  }
}
